import { Navigate } from 'react-router-dom';
import { App } from 'app';
import { AdminRoutes } from './admin';
import { AnalyticsRoutes } from './analytics';
import { ComplianceRoutes } from './compliance';
import { DashboardRoutes } from './dashboard';
import { ItemRoutes } from './item';
import { MarketingRoutes } from './marketing';
import { OrdersRoutes } from './orders';
import { ReportsRoutes } from './reports';
import { StyleRoutes } from './style';
import { StyleV2Routes } from './styleV2';
import { ItemV2Routes } from './itemV2';
import { SampleRequestsV2Routes } from './sampleRequestsV2';
import { SampleRequestsRoutes } from './sampleRequests';
import { ExampleRoutes } from './example';

import { TaskboardRoutes } from './taskboard';
import { SuppliersRoutes } from './suppliers';
import { DirectSuppliersRoutes } from './direct-suppliers';
import { BrandsRoutes } from './brands';
import { PurchaseOrderRoutes } from './purchase-orders';
import { SupplierRoutes } from './supplier';
import { PersonalSettingsRoutes } from './personal-settings';
import { MigrationRoutes } from './migration';
import { SettingsRoutes } from './settings';
import { ZapierRoutes } from './zapier';
import { ZapierDemo01Routes } from './zapier-demo-01';
import { useOrgType } from 'modules/accessControl/hooks/useOrg';
import { SendInviteAction } from 'features/suppliers/components/guidedOnboarding/SendInviteAction';
import { ErrorBoundary } from 'components/errorBoundary/ErrorBoundary';

const DefaultRoute = () => {
  const isSupplier = useOrgType(2);
  if (isSupplier) {
    return <Navigate to="/suppliers" replace />;
  }
  return <Navigate to="/style" replace />;
};

export const AppRoutes = [
  {
    path: '/',
    element: (
      <ErrorBoundary showDialog={false} dialogShouldRefresh={false}>
        <App topbarInviteActions={<SendInviteAction />} />
      </ErrorBoundary>
    ),
    children: [
      {
        path: '/',
        element: <DefaultRoute />,
      },
      DashboardRoutes,
      StyleRoutes,
      StyleV2Routes,
      ItemRoutes,
      ItemV2Routes,
      SampleRequestsV2Routes,
      SampleRequestsRoutes,
      OrdersRoutes,
      ReportsRoutes,
      AnalyticsRoutes,
      MarketingRoutes,
      ComplianceRoutes,
      AdminRoutes,
      ExampleRoutes,
      TaskboardRoutes,
      SuppliersRoutes,
      DirectSuppliersRoutes,
      BrandsRoutes,
      PurchaseOrderRoutes,
      SupplierRoutes,
      PersonalSettingsRoutes,
      MigrationRoutes,
      SettingsRoutes,
      ZapierRoutes,
      ZapierDemo01Routes,
    ],
  },
];
